import { render, staticRenderFns } from "./UserProfilePhoto.vue?vue&type=template&id=1b2c2cb3&scoped=true"
import script from "./UserProfilePhoto.vue?vue&type=script&lang=js"
export * from "./UserProfilePhoto.vue?vue&type=script&lang=js"
import style0 from "./UserProfilePhoto.vue?vue&type=style&index=0&id=1b2c2cb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2c2cb3",
  null
  
)

export default component.exports